import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

import enTranslation from './locales/en.json';
import frTranslation from './locales/fr.json';

const resources = {
  en: {
    translation: enTranslation
  },
  fr: {
    translation: frTranslation
  }
};

// Force English language regardless of localStorage
localStorage.setItem('language', 'en');

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // Always use English
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
});

// Override changeLanguage to prevent switching to French within the app
// (redirection is handled in Nav.js)
const originalChangeLanguage = i18n.changeLanguage;
i18n.changeLanguage = function(lng) {
  // If trying to change to French, let Nav.js handle the redirection
  if (lng === 'fr') {
    return originalChangeLanguage.call(this, 'en');
  }
  return originalChangeLanguage.call(this, lng);
};

// Force i18n.language to always return 'en' for API calls
Object.defineProperty(i18n, 'language', {
  get: function() { return 'en'; }
});

export default i18n;
